/**
 * ProtectedSection Component
 * A reusable component for password-protected sections
 * Used in Factory and Historical views
 */
import React, { useState } from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const ProtectedSection = ({
  title = "Sección Protegida",
  description = "Ingrese la contraseña para acceder a esta sección.",
  icon: Icon = Lock,
  iconClassName = "text-amber-500",
  onPasswordSubmit,
  children
}) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.trim()) {
      onPasswordSubmit(password);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-8 text-center max-w-md mx-auto mt-8">
      <Icon className={`w-16 h-16 mx-auto mb-4 ${iconClassName}`} />
      <h2 className="text-xl font-bold mb-2">{title}</h2>
      <p className="text-slate-600 mb-4">{description}</p>
      
      <form onSubmit={handleSubmit} className="space-y-3">
        <div className="relative">
          <Input
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder="Contraseña..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="pr-10"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
          >
            {showPassword ? (
              <EyeOff className="w-4 h-4" />
            ) : (
              <Eye className="w-4 h-4" />
            )}
          </button>
        </div>
        <Button type="submit" className="w-full">
          Acceder
        </Button>
      </form>
      
      {children}
    </div>
  );
};

export default ProtectedSection;
